if (!customElements.get('variant-thumbnail-gallery')) {
  customElements.define(
    'variant-thumbnail-gallery',
    class VariantThumbnailGallery extends HTMLElement {
      connectedCallback() {
        this.sliderComponent = this.querySelector('slider-component');
        this.slider = this.sliderComponent?.querySelector('.variant-thumbnail-list');

        this.addEventListener('click', this.handleThumbnailClick);
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => this.syncSelection());

        this.resizeObserver = new ResizeObserver(() => this.updateOverflow());
        if (this.slider) this.resizeObserver.observe(this.slider);

        requestAnimationFrame(() => {
          this.updateOverflow();
          this.syncSelection();
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleThumbnailClick);
        this.variantChangeUnsubscriber?.();
        this.resizeObserver?.disconnect();
      }

      handleThumbnailClick = (event) => {
        const thumbnail = event.target.closest('[data-option-value-id]');
        if (!thumbnail || !this.contains(thumbnail)) return;

        const optionValueId = thumbnail.dataset.optionValueId;
        const variantSelects = this.closest('product-info')?.querySelector('variant-selects');
        const optionControl = variantSelects?.querySelector(`[data-option-value-id="${CSS.escape(optionValueId)}"]`);
        if (!optionControl) return;

        this.setActiveThumbnail(optionValueId);

        if (optionControl.tagName === 'OPTION') {
          const select = optionControl.closest('select');
          select.value = optionControl.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        optionControl.checked = true;
        optionControl.dispatchEvent(new Event('change', { bubbles: true }));
      };

      syncSelection() {
        const variantSelects = this.closest('product-info')?.querySelector('variant-selects');
        const selectedThumbnail = Array.from(this.querySelectorAll('[data-option-value-id]')).find((thumbnail) =>
          variantSelects?.querySelector(
            `input[data-option-value-id="${CSS.escape(thumbnail.dataset.optionValueId)}"]:checked, option[data-option-value-id="${CSS.escape(thumbnail.dataset.optionValueId)}"][selected]`
          )
        );
        if (selectedThumbnail) this.setActiveThumbnail(selectedThumbnail.dataset.optionValueId);
      }

      setActiveThumbnail(optionValueId) {
        this.querySelectorAll('[data-option-value-id]').forEach((thumbnail) => {
          if (thumbnail.dataset.optionValueId === optionValueId) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });

        const activeItem = this.querySelector(`[data-option-value-id="${CSS.escape(optionValueId)}"]`)?.closest('li');
        if (!activeItem || !this.sliderComponent || this.sliderComponent.isSlideVisible(activeItem, 10)) return;
        this.slider.scrollTo({ left: activeItem.offsetLeft, behavior: 'smooth' });
      }

      updateOverflow() {
        if (!this.slider || !this.sliderComponent) return;
        const isOverflowing = this.slider.scrollWidth - this.slider.clientWidth > 1;
        this.sliderComponent.classList.toggle('is-overflowing', isOverflowing);
        this.sliderComponent.resetPages?.();
      }
    }
  );
}
